const HomeIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" aria-hidden="true" className="shrink-0">
    <path d="M8 28 L28 10 L48 28 V48 H8Z" fill="none" className="stroke-gold" strokeWidth="4" />
    <path d="M20 34l6 6 12-12" fill="none" className="stroke-ivory" strokeWidth="4" />
  </svg>
);
const DocIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" aria-hidden="true" className="shrink-0">
    <rect x="12" y="6" width="32" height="44" fill="none" className="stroke-gold" strokeWidth="4" />
    <path d="M19 18h18M19 27h18M19 36h10" className="stroke-ivory" strokeWidth="4" />
  </svg>
);
const LockIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" aria-hidden="true" className="shrink-0">
    <rect x="12" y="24" width="32" height="26" fill="none" className="stroke-gold" strokeWidth="4" />
    <path d="M18 24v-6a10 10 0 0 1 20 0v6" fill="none" className="stroke-ivory" strokeWidth="4" />
  </svg>
);

const GUARANTEES = [
  { Icon: HomeIcon, badge: "Haszonélvezeti jog", title: "Holtig tartó haszonélvezeti jog", text: "Otthonából senki nem költöztetheti ki" },
  { Icon: DocIcon, badge: "Ügyvédi jelenlét", title: "Hivatalos ügyvédi / közjegyzői szerződéskötés", text: "Saját ügyvéd is bevonható" },
  { Icon: LockIcon, badge: "Diszkréció", title: "Teljes diszkréció és tiszteletben tartott magánélet", text: null },
];

export const LegalSection = () => (
  <section id="garanciak" data-testid="legal-section" className="bg-navy text-ivory py-24 md:py-32">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[240px_1fr] gap-12">
      <div className="min-w-0">
        <p className="text-base uppercase tracking-[.14em] font-semibold text-gold">Jogi biztonság</p>
        <h2 className="disp uppercase mt-4" style={{ fontSize: "clamp(32px,4vw,56px)", lineHeight: 1.1 }}>
          Az Ön biztonsága az első
        </h2>
        <p className="disp text-gold mt-8 tab" style={{ fontSize: "clamp(64px,9vw,120px)", lineHeight: 1 }}>100%</p>
      </div>
      <div className="min-w-0 grid gap-6">
        {GUARANTEES.map(({ Icon, badge, title, text }, i) => (
          <div
            key={title}
            data-testid={`legal-guarantee-${i + 1}`}
            className={`fu c${i + 1} border-2 border-ivory/30 p-6 md:p-8 flex gap-6 items-start transition-colors hover:border-gold`}
          >
            <Icon />
            <div>
              <span className="inline-block border border-gold px-3 py-0.5 text-sm uppercase tracking-[.14em] text-gold">{badge}</span>
              <h3 className="text-xl md:text-2xl font-semibold mt-3">{title}</h3>
              {text && <p className="text-lg mt-2 text-ivory/85">{text}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
